<template>
  <div class="notice-editor">
    <div class="mb-4">
      <div class="label">หัวข้อ</div>
      <el-input v-model="value.title"></el-input>
    </div>
    <div class="mb-4">
      <div class="label">ข้อความ</div>
      <el-input v-model="value.subtitle"></el-input>
    </div>
    <div class="row mb-4">
      <div class="col-lg-6">
        <div class="label">ระยะเวลาติดประกาศ</div>
        <el-datepicker
          :disabled="language !== localization.TH"
          class="date-picker"
          type="daterange"
          range-separator="ถึง"
          :value="publishDate"
          @input="handleChangeDateTime('publishDate', $event)"
        ></el-datepicker>
      </div>
      <div class="col-lg-6">
        <div class="label">ตั้งค่าวันในปฎิทิน (optional)</div>
        <el-datepicker
          :disabled="language !== localization.TH"
          class="date-picker"
          type="daterange"
          range-separator="ถึง"
          :value="calendarDate"
          @input="handleChangeDateTime('calendarDate', $event)"
        ></el-datepicker>
      </div>
    </div>
    <div class="label">โครงการ</div>
    <project-selector
      :disabled="language !== localization.TH" v-model="value.projects"
      ></project-selector>
  </div>
</template>

<script>
import { Input, DatePicker, Checkbox } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ProjectSelector from "@/lib/components/ProjectSelector";
import { DateTime } from "luxon";
import { localization } from "@/lib/mapper";

export default {
  props: ["value", "language"],
  components: {
    ScButton,
    ProjectSelector,
    "el-input": Input,
    "el-datepicker": DatePicker,
    "el-checkbox": Checkbox
  },
  data() {
    return {
      localization
    };
  },
  watch: {},
  computed: {
    calendarDate() {
      if (!this.value.calendarDate) {
        return null;
      }

      const { start, end } = this.value.calendarDate;

      return [
        start.setZone("utc+7").toJSDate(),
        end.setZone("utc+7").toJSDate()
      ];
    },
    publishDate() {
      if (!this.value.publishDate) {
        return null;
      }

      const { start, end } = this.value.publishDate;

      return [
        start.setZone("utc+7").toJSDate(),
        end.setZone("utc+7").toJSDate()
      ];
    }
  },
  methods: {
    handleChangeDateTime(key, value) {
      if (!value) {
        this.$emit("input", { ...this.value, [key]: null });
        return;
      }

      const [startJSDate, endJSDate] = value;
      const start = DateTime.fromJSDate(startJSDate).toUTC();
      const end = DateTime.fromJSDate(endJSDate)
        .endOf("day")
        .toUTC();

      const dateTime = {
        start,
        end
      };
      const newValue = {
            ...this.value,
            [key]: dateTime
          };

      this.$emit("input", newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  margin-bottom: 5px;
  font-weight: bold;
}

.date-picker {
  width: 100%;
}

.checkbox {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/notices/components/NoticeEditor.vue